export default [
    {
        text: 'N° de factura',
        sortable: true,
        value: 'number',
    },
    {
        text: 'PROVEEDOR',
        sortable: false,
        fieldType: 'computed',
        computed: ({ sl_customer }) => sl_customer.alias_name,
    },
    {
        text: 'SUCURSAL',
        sortable: false,
        fieldType: 'computed',
        computed: ({ sl_customer_branch_offices }) => sl_customer_branch_offices.address,
    },
    {
        text: 'FECHA DE EMISIÓN',
        sortable: false,
        fieldType: 'computed',
        computed: ({ emission_date }) => emission_date,
    },
    {
        text: 'ESTADO',
        sortable: false,
        fieldType: 'computed',
        computed: ({ status }) => status,
    },
    {
        text: 'TOTAL',
        sortable: false,
        fieldType: 'computed',
        computed: ({ total }) => total,
    },
    {
        text: 'SALDO',
        sortable: false,
        fieldType: 'computed',
        computed: ({ account_receivable }) => account_receivable.balance,
    },
    {
        text: 'MONTO A PAGAR',
        editable: true,
        fieldType: 'text',
        format: 'currency',
        sortable: false,
        value: 'amount_to_pay',
    },
]